import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Fees = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>School Fees</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Rules</li>
                    <li>|</li>
                    <li>School Fees</li>
                </ul>
            </div>
            <div className="inner_page uniform_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7">
                            
                            <ul className="list-view">
                               <li> Fees should be deposited in any one of the working days as specified in the fee-book (see year-plan) in the beginning of the months.</li>
                               <li>All the details of the fee collection are given on the fee Account Books.</li>
                               <li>The children who take new admission will pay one month's tuition fee along with the admission fee, maintenance fee, Establishment charges and Annual charges. Annual Charges and maintenance fee will be charged very year.</li>
                               <li>A student may be permitted to write the examination without fee clearance, on a written request form the parents, after submitting a written undertaking that they well not demand the result of their ward till the payment is done.</li>
                               <li>Fees once paid will not refunded.</li>
                               <li>Fee defaulters will be charged Rs.50 per month and Rs.150 for two months as fine. The students are liable to have their names struck off the rolls, if they make default in paying fee for more than two consecutive installments.</li>
                               <li>Fee for any number of months, even for the whole year can be paid in advance.</li>
                               <li>Tuition fees will be charged for the whole year even though a child is admitted in the middle of a term. Maintenance levy will be charged every year., The annual fees which comprise consumable expenses on the students, such s: electricity, water, sanitation and hygiene, first aid and health services, security, sport and games, HRD & welfare schemes, personal growth assistance like seminars and motivational pro grammars, generator, office expenses, etc. will also be charged every year. However, the admission fee will be charged only at the admission, with an additional ICSE entrance/enrollment t charge at the time of admission to the 1st std.</li>
                               <li>As long as the school does not receive any grant in aid form the Govt., the school is constrained to revise the fees structure annually to meet the rise in expenditure due to the increase of the cost of living. The enhanced rates of tuition fee and other dues if any will be informed at the time of admission in March.</li>
                               <li>Class-IX student have to pay I.C.S. E. Registration fees and X- class I.C.S. E. exam. Fees, in addition to the regular fees.</li>
                            </ul>
                        </div>
                        
                        <div className="col-md-5">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/payment.gif" className="img-fluid" alt="st francis school, amritsar" /></LazyLoad>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Fees
